import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

import AdContainer from '@/components/ads/ad-container';
import { ContainerDef } from '@/components/ads/ad-container-ids';
import Newsletter from '@/components/pages/frontpage/components/feature/right/newsletter';
import subscribeToNewsletter from '@/utils/functions/subscribe-to-newsletter';

type RightRailProps = {
    showNewsletter?: boolean;
    adContainer?: ContainerDef;
    className?: string;
};

const RightRail = (props: RightRailProps) => {
    const { adContainer, showNewsletter, className } = props;

    return (
        <div className={cn('flex flex-col md:flex-row lg:flex-col border-l items-baseline self-stretch', className)}>
            {showNewsletter && (
                <Newsletter
                    title="Newsletter"
                    subTitle="The Breakdown"
                    description="Decoding crypto and the markets. Daily, with Byron Gilliam."
                    inputPlaceholder="Email address"
                    buttonText="subscribe"
                    onButtonClick={subscribeToNewsletter}
                    className="border-0 lg:border-b w-full"
                />
            )}
            {adContainer && (
                <div
                    className="lg:p-6 lg:pb-12 w-full overflow-hidden relative lg:sticky top-8 justify-center text-center align-middle"
                    style={{ alignSelf: 'start' }}
                >
                    <AdContainer
                        googleAd={adContainer}
                        className="hidden lg:flex mt-8 items-center justify-center mx-auto"
                    />
                </div>
            )}
        </div>
    );
};

export default RightRail;
